import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { MatTable } from '@angular/material/table';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { PrePaidModalComponent } from '../pre-paid-modal/pre-paid-modal.component';
@Component({
  selector: 'app-admin-utility-pre-providers',
  templateUrl: './admin-utility-pre-providers.component.html',
  styleUrls: ['./admin-utility-pre-providers.component.css'],
})
export class AdminUtilityPreProvidersComponent implements OnInit {
  @ViewChild('prePaidPaginator', { read: MatPaginator })
  prePaidPaginator: MatPaginator;

  @ViewChild(MatTable, { static: true })
  table: MatTable<any>;
  blocks: prePaidBlock[];
  dataSource: MatTableDataSource<prePaidBlock>;
  prePaidDisplayedColumns: string[] = [
    'action',
    'ProviderName',
    'EnergyRate',
    'UtilityName',
    'TDSPRatePerMonth',
    // 'TDSPRatePerkWh',
    'FiveHundredkWh',
    'ThousandkWh',
    'TwoThousandkWh',
    'EFL',
    'TDU_Charges_Month',
    'TDU_Charges_Kwh'
  ];

  selected: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService,
    public dialog: MatDialog //private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.getPrepaidProvidersInfo();
  }
  getPrepaidProvidersInfo() {
    this.residentialService
      .getPrepaidProvidersInfo()
      .subscribe((response: any) => {
        console.log(response);
        this.blocks = response;
        this.dataSource = new MatTableDataSource<prePaidBlock>(this.blocks);
        this.dataSource.paginator = this.prePaidPaginator;
      });
  }
  createPrePaidDialog(action, itemData?): void {
    const dialogRef = this.dialog.open(PrePaidModalComponent, {
      width: '1000px',
      data: { pageValue: this.blocks, action, itemData },

      // data: {name: this.nacdme, animal: this.animal},
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      // this.animal = result;
      this.getPrepaidProvidersInfo();
    });
  }

  checkForWholeOrDecimal(number) {
    if (number == Math.floor(number)) {
      return `${number}.00`;
    } else {
      const newValue = number.toString();
      const newString =
        newValue.substring(newValue.indexOf('.') + 1).length >= 2
          ? newValue.substring(newValue.indexOf('.') + 1)
          : `${newValue.substring(newValue.indexOf('.') + 1)}0`;
      return `${newValue.substring(0, newValue.indexOf('.'))}.${newString}`;
    }
  }
  // onChageProvider(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.tduData.filter = filterValue.trim().toLowerCase();
  // }
}
export interface prePaidBlock {
  Abbreviation: string;
  ProviderName: string;
  EnergyRate: number;
  UtilityName: string;
  TDSPRatePerMonth: number;
  // TDSPRatePerkWh: number;
  FiveHundredkWh: number;
  ThousandkWh: number;
  TwoThousandkWh: number;
  EFL: string;
  TDU_Charges_Month: number;
  TDU_Charges_Kwh: string;
}
